import { render, staticRenderFns } from "./UiPost.vue?vue&type=template&id=4acd29df&"
import script from "./UiPost.vue?vue&type=script&lang=js&"
export * from "./UiPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports